/**
 * Every origin an ai_thread can be created from. Canonical source for the
 * DB column type and the admin/list filters — add new origins here.
 */
export const AI_THREAD_CREATED_FROM = [
    'slack',
    'web_app',
    'api',
    'evals',
    'scheduler',
    'data_app',
];
// Subsets use indexed access over const arrays (not Exclude<>, which tsoa
// can't resolve at API boundaries); `satisfies` keeps each subset inside the
// canonical union.
/** Origins for threads created through the web app path — everything but Slack. */
export const AI_WEB_APP_THREAD_CREATED_FROM = [
    'web_app',
    'api',
    'evals',
    'scheduler',
    'data_app',
];
/**
 * Threads a person owns in the app. An `api` thread is the same thread started
 * with an access token instead of a browser session, so it must behave alike.
 */
export const AI_APP_THREAD_CREATED_FROM = [
    'web_app',
    'api',
];
export const isAiAppThreadCreatedFrom = (createdFrom) => AI_APP_THREAD_CREATED_FROM.includes(createdFrom);
/** Threads started by a person, as opposed to evals, schedules and data apps. */
export const AI_USER_THREAD_CREATED_FROM = [
    ...AI_APP_THREAD_CREATED_FROM,
    'slack',
];
/** Origins handled through the Slack path. */
export const AI_SLACK_THREAD_CREATED_FROM = [
    'slack',
    'web_app',
];
/** Origins a thread can be cloned into — Slack and scheduler threads are never clone targets. */
export const AI_CLONED_THREAD_CREATED_FROM = [
    'web_app',
    'evals',
];
export const isSlackPrompt = (prompt) => 'slackUserId' in prompt;
//# sourceMappingURL=requestTypes.js.map